export class ToDoListsCountsDto {
  // Pre-Importation
  waitingOnExporter?: number = undefined
  needsSpecialBond?: number = undefined
  needsManufacturerLabelImageExporter?: number = undefined
  needsTPMSLabelImageExporterPerAppendixB?: number = undefined
  needsBWIApproval?: number = undefined
  needsToBeAddedToAPAPS?: number = undefined
  cancelled?: number = undefined

  // Importation
  needsBrokerDocuments?: number = undefined
  needsSignedForeignShipper?: number = undefined
  waitingOnTrip?: number = undefined
  needsCheckIn?: number = undefined
  needsManufacturerLabel?: number = undefined
  needsTirePressureLabel?: number = undefined
  needsPhotos?: number = undefined

  // Recall
  needsOEMSiteCheckedForRecalls?: number = undefined
  needsCAROUploaded?: number = undefined
  needsRecallWork?: number = undefined

  // Cluster
  needsClusterRemoved?: number = undefined
  needsClusterConversionShipper?: number = undefined
  needsClusterDeliveredToThirdPartyConversionCompany?: number = undefined
  waitingOnThirdPartyClusterConversion?: number = undefined
  needsClusterConversionInHouse?: number = undefined
  needsClusterConversionDetermination?: number = undefined
  needsInHouseConversion?: number = undefined
  inConversion?: number = undefined
  needsClusterReinstalledAfterInHouseConversion?: number = undefined
  needsClusterReinstalledAfterThirdPartyConversion?: number = undefined
  needsClusterInstallCompleted?: number = undefined
  needsClusterProgrammingDetermination?: number = undefined
  needsInHouseClusterProgramming?: number = undefined
  needsInHouseAdditionalProgramming?: number = undefined
  inInHouseProgramming?: number = undefined
  needsThirdPartyClusterProgramming?: number = undefined
  needsThirdPartyAdditionalProgramming?: number = undefined
  waitingOnThirdPartyAdditionalProgramming?: number = undefined
  needsClusterReinstalled?: number = undefined
  needsClusterReinstalledAfterInHouseProgramming?: number = undefined
  needsClusterReinstalledAfterThirdPartyProgramming?: number = undefined
  needsIncorrectMileageResolution?: number = undefined

  // Michigan Titles
  needs7501DocumentMichigan?: number = undefined
  needsCANOwnershipMichigan?: number = undefined
  needsInfoForApplicationPacketMichigan?: number = undefined
  needsToBePrintedAndSigned?: number = undefined
  needsToBeTakenToSecretaryOfState?: number = undefined
  needsMichiganTitleApplicationReceipt?: number = undefined
  needsMichiganTitleFromSecretaryOfState?: number = undefined
  michiganTitlesNeedsToBeSentOutgoing?: number = undefined

  // Ohio Titles
  needs7501DocumentOhio?: number = undefined
  needsCANOwnershipOhio?: number = undefined
  needsInfoForApplicationPacketOhio?: number = undefined
  needsToBeMarkedReadyForBuildABox?: number = undefined
  needsToBeAddedToABundle?: number = undefined
  needsToHaveBoxFinished?: number = undefined
  needsToBeTakenToFedEx?: number = undefined
  waitingOnOhioTitleProcessing?: number = undefined
  needsNewTitlesOCRd?: number = undefined
  needsToBeReadyForBox?: number = undefined
  needsToBeReadyForShipToOhio?: number = undefined
  needsToBePutInABox?: number = undefined
  readyToSendToOhio?: number = undefined
  shippedToOhio?: number = undefined
  receivedInOhio?: number = undefined
  inProcessInOhio?: number = undefined
  ohioTitlesNeedsToBeSentOutgoing?: number = undefined

  // Conformity
  vehiclesEligibleForConformity?: number = undefined
  approaching120DaysSinceEntryDate?: number = undefined
  sendBackToCanada?: number = undefined
  needsTripEntryInfo?: number = undefined
  needsConformityPhotos?: number = undefined
  needsOEMSiteDoublecheck?: number = undefined
  needsConformitySentToDOT?: number = undefined
  conformitySentToDOT?: number = undefined

  // Outbound Trips
  readyForOutboundTrip?: number = undefined
  needsToBeMovedToStaging?: number = undefined
  needsDriversLicensePhotoUploaded?: number = undefined
  needsSignedBOL?: number = undefined
  needsOutboundPhotos?: number = undefined
  needsRecallWarrantyInGlovebox?: number = undefined
  needsOutboundTransport?: number = undefined

  // Invoicing
  needToInvoice?: number = undefined

  // Other
  needsDamageRepaired?: number = undefined
  created5DaysAgoOrMoreAndHasNotBeenSentToDOT?: number = undefined
  archived?: number = undefined
}
